import React from 'react';
import RadioComponent from 'shared/components/RadioComponent';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';

const Panelize = (props) => {
  const name = 'panelize';

  const {
    groupName,
    errorMessage,
    onChangeParameter,
    parameters,
    label,
    required,
    yesLabel,
    yesValue,
    noLabel,
    noValue,
    tooltip,
    className,
    inputClassName,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <div className="form-group">
      <Label label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={parameters[name] === noValue}
          className={className}
          inputClassName={inputClassName}
          inputId={`panelize-no-${groupName}`}
          inline
          label={noLabel}
          name={name}
          onChange={onChange}
          groupName={groupName}
          value={noValue} />
        <RadioComponent
          {...props}
          checked={parameters[name] === yesValue}
          className={className}
          inputClassName={inputClassName}
          inputId={`panelize-yes-${groupName}`}
          inline
          label={yesLabel}
          name={name}
          onChange={onChange}
          groupName={groupName}
          value={yesValue} />
        <div className="error-place" />
      </div>
      <div className="error">
        {errorMessage}
      </div>
    </div>
  );
};

Panelize.defaultProps = {
  options: [],
  label: Spree.translations.parameters.panelize,
  tooltip: Spree.helpForParameters.panelize,
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel: 'No',
  noValue: '0',
};

export default Panelize;
